'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/hooks/useFilterState.ts
import { useMemo } from "react";
import { useRouter } from "@wbk/config";
import { splitDateTime } from "@wbk/utils";
var defaultState = {
  page: 1,
  sort: "",
  perPage: 12,
  time: []
};
var useFilterState = () => {
  const { search: searchParams, setSearch, pathname, push } = useRouter();
  const state = useMemo(() => {
    const category = searchParams.get("category") || defaultState.category;
    const subcategory = searchParams.get("subcategory") || defaultState.subcategory;
    const search = searchParams.get("search") || defaultState.search;
    const date = searchParams.get("date") || defaultState.date;
    const dateFrom = searchParams.get("from") || defaultState.from;
    const dateTo = searchParams.get("to") || defaultState.to;
    const from = dateFrom ? new Date(dateFrom) : defaultState.from;
    const to = dateTo ? new Date(dateTo) : defaultState.to;
    const minPrice = searchParams.get("minPrice") || defaultState.minPrice;
    const maxPrice = searchParams.get("maxPrice") || defaultState.maxPrice;
    const organizer = searchParams.getAll("organizer");
    const page = searchParams.get("page") ? Number(searchParams.get("page")) : 1;
    const sort = searchParams.get("sort") || defaultState.sort;
    const minTemp = Number(searchParams.get("minTemp")) || void 0;
    const maxTemp = Number(searchParams.get("maxTemp")) || void 0;
    const perPage = defaultState.perPage;
    const tag = searchParams.get("tag") || void 0;
    return {
      category,
      subcategory,
      search,
      date,
      from,
      to,
      page,
      sort,
      minPrice,
      maxPrice,
      organizer,
      perPage,
      minTemp,
      maxTemp,
      tag
    };
  }, [searchParams]);
  const total = useMemo(() => {
    let total2 = 0;
    const exclude = ["page", "perPage", "from", "to", "minPrice", "search"];
    for (const s in state) {
      const key = s;
      const value = state[key];
      if (!value || exclude.includes(key))
        continue;
      if (Array.isArray(value)) {
        total2 += value.length;
      } else {
        total2++;
      }
    }
    return total2;
  }, [state]);
  const setState = (data) => {
    const newState = __spreadProps(__spreadValues(__spreadValues({}, state), data), {
      // Reset page to 1 when changing filters
      page: !data.page || data.page <= 1 ? "" : data.page
    });
    const params = {};
    for (const key in newState) {
      const k = key;
      if (k === "perPage")
        continue;
      const value = newState[k];
      if (value) {
        if (k === "from" || k === "to") {
          params[k] = splitDateTime(value, "en", { month: "2-digit", day: "2-digit" }).date;
        } else {
          params[k] = value;
        }
      }
    }
    setSearch(params, { replace: true });
  };
  const reset = () => {
    const params = new URLSearchParams();
    if (state.search) {
      params.set("search", state.search);
    }
    const queryString = params.toString();
    push(pathname + (queryString ? "?" + queryString : ""));
  };
  return { state, setState, reset, total };
};

export {
  useFilterState
};
//# sourceMappingURL=chunk-TOSXVIFC.mjs.map